import API from '../../API';
import {
  bookmarkToggleActionCreator,
  commentOnPostSuccessActionCreator,
  deletePostSuccessActionCreator,
  commentLikeToggleActionCreator,
  fetchCommentsSuccessActionCreator,
  deleteCardActionCreator,
  replyLikeToggleActionCreator,
  fetchFeedFailureActionCreator,
  fetchFeedRequestActionCreator,
  fetchFeedSuccessActionCreator,
  fetchPostFailureActionCreator,
  fetchPostRequestActionCreator,
  fetchPostSuccessActionCreator,
  likeToggleActionCreator,
  purchasePostSuccessActionCreator,
  setFeedUserIdActionCreator,
  pinPostFailureActionCreator,
  pinPostRequestActionCreator,
  pinPostSuccessActionCreator,
  fetchStatisticsActionCreator,
  fetchStatisticsSuccessActionCreator,
  fetchStatisticsFailureActionCreator,
  fetchPostStatisticsActionCreator,
  fetchPostStatisticsSuccessActionCreator,
  fetchPostStatisticsFailureActionCreator,
  replyOnCommentCreator,
} from './feed.actionCreators';

export const fetchFeed = (uid = null, params = {}, customURL) => {
  return async (dispatch, getState) => {
    dispatch(fetchFeedRequestActionCreator());
    let url = `/posts${uid ? '/' + uid : ''}`;

    if (customURL) {
      url = customURL;
    }

    return await API.get(url, params)
      .then(resp => {
        const { user } = getState().auth;
        dispatch(fetchFeedSuccessActionCreator(resp, user));
        if (uid) {
          dispatch(setFeedUserId(uid));
        }
        return resp;
      })
      .catch(err => {
        dispatch(fetchFeedFailureActionCreator(err));
        throw err;
      });
  };
};

export const fetchStatistics = (uid = null, params = {}, customUrl) => {
  return async dispatch => {
    dispatch(fetchStatisticsActionCreator());
    return await API.get(customUrl, params)
      .then(resp => {
        dispatch(fetchStatisticsSuccessActionCreator(resp));
        return resp;
      })
      .catch(err => {
        dispatch(fetchStatisticsFailureActionCreator(err));
        throw err;
      });
  };
};

export const fetchPostStatistics = (uid = null, params = {}, customUrl) => {
  return async dispatch => {
    let url = `/posts/${uid}/statistics`;

    dispatch(fetchPostStatisticsActionCreator());
    return await API.get(url, params)
      .then(resp => {
        dispatch(fetchPostStatisticsSuccessActionCreator(resp));
        return resp;
      })
      .catch(err => {
        dispatch(fetchPostStatisticsFailureActionCreator(err));
        throw err;
      });
  };
};

export const setFeedUserId = uid => {
  return async dispatch => {
    dispatch(setFeedUserIdActionCreator(uid));
  };
};

export const createPost = params => {
  return async dispatch => {
    return await API.post(`/posts`, params, true)
      .then(resp => {
        dispatch(fetchPostSuccessActionCreator(resp));
        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};
export const deleteCard = param => {

  return async dispatch => {
    return await API.delete(`/payments/credit-cards`, param, true)
      .then(resp => {
        // dispatch(deleteCardActionCreator());

        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};

export const paymentHistory = param => {

  return async dispatch => {
    return await API.get(`/payments/history`, param, true)
      .then(resp => {
        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};
export const registeredCard = param => {

  return async dispatch => {
    return await API.get(`/payments/credit-cards`, param, true)
      .then(resp => {
        console.log(resp)
        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};
export const saveCard = token => {

  return async dispatch => {
    return await API.post(`/payments/credit-cards`, { pf_token: token }, true)
      .then(resp => {
        console.log(resp)
        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};
export const cardToken = params => {
  return async dispatch => {
    return await API.get(`/payments/pf-token`, params, true)
      .then(resp => {
        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};

export const updatePost = (id, params) => {
  return async dispatch => {
    return await API.post(`/posts/${id}`, params, true)
      .catch(err => {
        throw err;
      });
  };
};
export const deletePostPhoto = id => {
  return async dispatch => {
    return await API.post(`/post/media/${id}`, true)
      .catch(err => {
        throw err;
      });
  };
};

export const likeToggle = id => {
  return async dispatch => {
    dispatch(likeToggleActionCreator(id));
    return await API.post(`/posts/${id}/like`)
      .then(resp => {
        return resp;
      })
      .catch(err => {
        dispatch(likeToggleActionCreator(id));
        throw err;
      });
  };
};
export const bookmarkToggle = id => {
  return async dispatch => {
    dispatch(bookmarkToggleActionCreator(id));
    return await API.post(`/posts/${id}/bookmark`)
      .then(resp => {
        return resp;
      })
      .catch(err => {
        dispatch(bookmarkToggleActionCreator(id));
        throw err;
      });
  };
};

export const fetchComments = (id, page = 1) => {
  return async dispatch => {
    return await API.get(`/posts/${id}/comments`, { page })
      .then(resp => {
        dispatch(fetchCommentsSuccessActionCreator(id, resp));
        return resp;
      })
      .catch(err => {
        console.log('fetch comments error', err);
        throw err;
      });
  };
};
export const commentOnPost = (id, body) => {
  return async dispatch => {
    return await API.post(`/posts/${id}/comment`, { body })
      .then(resp => {
        dispatch(commentOnPostSuccessActionCreator(id, resp));
        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};
export const commentLikeOnPost = (id) => {
  return async dispatch => {
    dispatch(commentLikeToggleActionCreator(id));
    return await API.post(`/comment/${id}/like`)
      .then(resp => {
        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};
export const replyLikeOnPost = (id, commentId, forFeed) => {
  return async dispatch => {
    dispatch(replyLikeToggleActionCreator(id, commentId, forFeed));
    return await API.post(`/comment/${id}/like`)
      .then(resp => {
        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};

export const replyOnComment = (id, body, postId) => {
  return async dispatch => {
    return await API.post(`comment/${id}/reply`, { body })
      .then(resp => {
        dispatch(replyOnCommentCreator(id, postId, resp));
        return resp;
      })
      .catch(err => {
        console.log(err, 'err');
        throw new Error(err);
      });
  };
};

export const deleteComment = id => {
  return async dispatch => {
    //dispatch(fetchPostRequestActionCreator());
    return await API.delete(`/posts/comments/${id}`)
      .then(resp => {
        //dispatch(fetchPostSuccessActionCreator(resp));
        return resp;
      })
      .catch(err => {
        //dispatch(fetchPostFailureActionCreator());
        throw err;
      });
  };
};

export const fetchPost = id => {
  return async dispatch => {
    dispatch(fetchPostRequestActionCreator());
    return await API.get(`/post/${id}`)
      .then(resp => {
        dispatch(fetchPostSuccessActionCreator(resp));
        return resp;
      })
      .catch(err => {
        dispatch(fetchPostFailureActionCreator());
        throw err;
      });
  };
};
export const fetchFeedPost = id => {
  return async dispatch => {
    dispatch(fetchPostRequestActionCreator());
    return await API.get(`/post/${id}`)
      .then(resp => {
        dispatch(fetchPostSuccessActionCreator(resp));
        return resp;
      })
      .catch(err => {
        dispatch(fetchPostFailureActionCreator());
        throw err;
      });
  };
};

export const deletePost = id => {
  return async dispatch => {
    return await API.delete(`/posts/${id}`)
      .then(resp => {
        dispatch(deletePostSuccessActionCreator(id));
        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};

export const purchasePost = id => {
  return async dispatch => {
    return await API.post(`/payments/post/${id}`)
      .then(resp => {
        dispatch(purchasePostSuccessActionCreator(resp));
        return resp;
      })
      .catch(err => {
        throw err;
      });
  };
};

export const pinPost = (id, params) => async dispatch => {
  dispatch(pinPostRequestActionCreator());
  try {
    const responseData = await API.post(`/posts/${id}/pin`, params);
    dispatch(pinPostSuccessActionCreator(responseData));
  } catch (e) {
    return dispatch(pinPostFailureActionCreator());
  }
};
